export default {"src":"/_next/static/media/favorite-hover.35178f32.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};